import { Button } from '../../../ui';

const OfferModal = () => {
  return (
    <div className="flex flex-col gap-[32px] px-[32px] py-[48px] rounded-[10px] bg-white absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center shadow-md">
      <svg width="42" height="30" viewBox="0 0 42 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M39.3333 2L13.6667 27.6667L2 16" stroke="#09AF77" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <div className="flex flex-col items-center gap-[16px] text-[#000000]">
        <h3 className="text-[24px] md:text-[32px] font-semibold md:leading-[40px] leading-[29px]">Շնորհակալություն </h3>
        <span className="md:text-[18px] text-[16px]">Ձեր հարցումն ուղարկվել է</span>
      </div>
      <a href="/" rel="noreferrer">
        <Button variant="blackOffer" className="md:w-[220px] w-full hover:md:w-[210px]">
          Գլխավոր էջ
        </Button>
      </a>
    </div>
  );
};

export default OfferModal;
